import React from 'react';
import { Card, Descriptions, Typography } from '../../../components';

const { Text } = Typography;

export const Webmin = ({ appliance, logsUrl, cloudAccountType }) => {
    let applianceManagementCardTitle;

    if (['rivermeadow_standalone', 'nc2', 'hpe_vme', 'openshift'].includes(cloudAccountType)) {
        applianceManagementCardTitle = 'Migration Appliance Management';
    } else if (cloudAccountType === 'azure_dr') {
        applianceManagementCardTitle = 'Backup Appliance Management';
    } else if (['vsphere_dr', 'vsphere_offline_replicas'].includes(cloudAccountType)) {
        applianceManagementCardTitle = 'DR Site RMS Appliance Management';
    } else {
        applianceManagementCardTitle = 'Appliance Management';
    }

    return (
        <Card title={applianceManagementCardTitle} size="small">
            <Descriptions column={1} size="small">
                <Descriptions.Item label="URL:">
                    {(
                        <a href={appliance.webminURL} target="_blank">
                            {appliance.webminURL}
                        </a>
                    ) || 'Not available'}
                </Descriptions.Item>
                <Descriptions.Item label="Username:">
                    <Text>{appliance.webminUserName || 'Not available'}</Text>
                </Descriptions.Item>
                <Descriptions.Item label="Password:">
                    <Text>{appliance.webminPassword || 'Not available'}</Text>
                </Descriptions.Item>
                {logsUrl && <a href={logsUrl}>Logs</a>}
            </Descriptions>
        </Card>
    );
};
